export const PERFORMANCE_STAT_ROWS = [
  { key: "total_trades", label: "Total Trades", getValue: (stats) => stats.total_trades },
  { key: "wins", label: "Wins", getValue: (stats) => stats.wins },
  { key: "losses", label: "Losses", getValue: (stats) => stats.losses },
  { key: "scratch", label: "Scratch", getValue: (stats) => stats.scratch },
  { key: "win_ratio", label: "Win Ratio", getValue: (stats) => `${stats.win_ratio}%` },
  { key: "total_profit", label: "Total Net Profit", getValue: (stats) => `GBP ${stats.total_profit}` },
  { key: "percentage_gain", label: "Gain", getValue: (stats) => `${stats.percentage_gain}%` },
  { key: "max_drawdown", label: "Max Drawdown", getValue: (stats) => `GBP ${stats.max_drawdown}` },
  { key: "max_drawdown_percent", label: "Max Drawdown %", getValue: (stats) => `${stats.max_drawdown_percent}%` },
  { key: "long_trade", label: "Buys", getValue: (stats) => `${stats.long_trade} (${stats.long_trade_percent}%)` },
  { key: "short_trade", label: "Sells", getValue: (stats) => `${stats.short_trade} (${stats.short_trade_percent}%)` },
  { key: "profit_factor", label: "Profit Factor", getValue: (stats) => stats.profit_factor },
  { key: "gross_profit", label: "Gross Profit", getValue: (stats) => `GBP ${stats.gross_profit}` },
  { key: "gross_loss", label: "Gross Loss", getValue: (stats) => `GBP ${stats.gross_loss}` },
  { key: "average_win", label: "Avg Win", getValue: (stats) => `GBP ${stats.average_win}` },
  { key: "average_loss", label: "Avg Loss", getValue: (stats) => `GBP ${stats.average_loss}` },
  { key: "average_pips", label: "Avg Pips", getValue: (stats) => stats.average_pips },
  { key: "average_risk_reward", label: "Avg RR", getValue: (stats) => stats.average_risk_reward },
  { key: "average_trade_duration", label: "Avg Trade Duration (Days)", getValue: (stats) => stats.average_trade_duration },
  {
    key: "average_winning_trade_duration",
    label: "Avg Winning Trade Duration (Days)",
    getValue: (stats) => stats.average_winning_trade_duration,
  },
  {
    key: "average_losing_trade_duration",
    label: "Avg Losing Trade Duration (Days)",
    getValue: (stats) => stats.average_losing_trade_duration,
  },
  { key: "sharpe_ratio", label: "Sharpe Ratio", getValue: (stats) => stats.sharpe_ratio },
  { key: "max_consecutive_wins", label: "Max Win Streak", getValue: (stats) => stats.max_consecutive_wins },
  { key: "max_consecutive_losses", label: "Max Loss Streak", getValue: (stats) => stats.max_consecutive_losses },
  { key: "best_symbol", label: "Best Pair", getValue: (stats) => stats.best_symbol || "-" },
  { key: "best_symbol_profit", label: "Best Pair Net Profit", getValue: (stats) => `GBP ${stats.best_symbol_profit}` },
  { key: "best_magic", label: "Best Strategy", getValue: (stats) => stats.best_magic || "-" },
  { key: "best_magic_profit", label: "Best Strategy Net Profit", getValue: (stats) => `GBP ${stats.best_magic_profit}` },
];

export const createDefaultStatsVisibility = () => (
  PERFORMANCE_STAT_ROWS.reduce((visibility, stat) => {
    visibility[stat.key] = true;
    return visibility;
  }, {})
);

export const normalizeStatsVisibility = (savedVisibility = {}) => (
  PERFORMANCE_STAT_ROWS.reduce((visibility, stat) => {
    visibility[stat.key] = savedVisibility?.[stat.key] !== false;
    return visibility;
  }, {})
);
